/** Shared timing, geometry, and styling constants for the barcode-tracker
 *  overlay. Values match the iOS native implementation
 *  (client/ios-overlay/App/App/BarcodeTrackerOverlay.swift +
 *  CsCameraController.swift) so the cross-platform behavior stays in lockstep.
 *  Single source of truth for any future cross-platform tweak.
 */

export const MORPH_DURATION_MS = 120;
export const HOLD_DURATION_MS = 400;
export const TAKEOVER_AREA_RATIO = 1.5;
export const MISSING_FRAME_GRACE = 2;
export const EMA_ALPHA = 0.35;
export const IDLE_SIDE_FRACTION = 0.60;

export const STROKE_WIDTH_PX = 2.5;
export const BRACKET_ARM_MAX_PX = 14;
export const BRACKET_ARM_FRACTION = 0.4;
// matches $radius-md
export const BRACKET_CORNER_RADIUS_PX = 8;

export const IDLE_STROKE_COLOR = '#FFFFFF';
// matches $yellow-300 at client/src/theme/_colors.scss:80; iOS uses
// UIColor.systemYellow ≈ #FFCC00 Light Mode
export const DETECTED_STROKE_COLOR = '#F7C934';
